import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'HideDefaultNullValue',
})
export class HideDefaultNullValuePipe implements PipeTransform {
  transform(value: undefined | null | string | number): any {
    return value === '--' ? null : value;
  }
}
